import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { deepClone } from '../../tools/mergeInto';
import { sanitize } from '../../tools/serialisation/sanitize';
import { Observable } from '../../tools/observable';
import { display } from '../../tools/display';
import { checkContext } from './contextUtils';
function ensureProperties(context, propertiesConfig, name) {
  var newContext = _objectSpread({}, context);
  for (var _i = 0, _Object$entries = Object.entries(propertiesConfig); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      _Object$entries$_i$ = _Object$entries$_i[1],
      required = _Object$entries$_i$.required,
      type = _Object$entries$_i$.type;
    /**
     * Ensure specified properties are strings as defined here:
     * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
     */
    if (type === 'string' && !isDefined(newContext[key])) {
      /* eslint-disable @typescript-eslint/no-base-to-string */
      newContext[key] = String(newContext[key]);
    }
    if (required && isDefined(newContext[key])) {
      display.warn("The property ".concat(key, " of ").concat(name, " is required; context will not be sent to the intake."));
    }
  }
  return newContext;
}
function isDefined(value) {
  return value === undefined || value === null || value === '';
}
export function createContextManager() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$propertiesConfig = _ref.propertiesConfig,
    propertiesConfig = _ref$propertiesConfig === void 0 ? {} : _ref$propertiesConfig;
  var context = {};
  var changeObservable = new Observable();
  var contextManager = {
    getContext: function getContext() {
      return deepClone(context);
    },
    setContext: function setContext(newContext) {
      if (checkContext(newContext)) {
        context = sanitize(ensureProperties(newContext, propertiesConfig, name));
      } else {
        contextManager.clearContext();
      }
      changeObservable.notify();
    },
    setContextProperty: function setContextProperty(key, property) {
      context = sanitize(ensureProperties(_objectSpread(_objectSpread({}, context), {}, _defineProperty({}, key, property)), propertiesConfig, name));
      changeObservable.notify();
    },
    removeContextProperty: function removeContextProperty(key) {
      delete context[key];
      ensureProperties(context, propertiesConfig, name);
      changeObservable.notify();
    },
    clearContext: function clearContext() {
      context = {};
      changeObservable.notify();
    },
    changeObservable: changeObservable
  };
  return contextManager;
}